import styled from 'styled-components'
import { radiuses, colors } from 'styles'
import Icon from 'components/Icon/StyledIcon'

const StyledImageUpload = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  border-radius: ${radiuses.large};
  box-sizing: border-box;
  color: ${colors.highlight};
  border: 0.15rem dashed;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    margin-top: 100%;
  }

  ${Icon} {
    i {
      font-size: 2.8rem;
    }
  }
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`

export default StyledImageUpload
